import {BASE_URL} from './app.tokens';

import {APP_INITIALIZER, LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule, Title} from '@angular/platform-browser';


import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {MATERIAL} from './shared/util/material.modules';
import {FlexLayoutModule} from '@angular/flex-layout';

import {ChartModule, HIGHCHARTS_MODULES} from 'angular-highcharts';
import * as Highcharts from 'highcharts';
import * as exporting from 'highcharts/modules/exporting.src';
import * as more from 'highcharts/highcharts-more.src';

import {CommonModule, registerLocaleData} from '@angular/common';
import localeDe from '@angular/common/locales/de';

import {EnergyFrameModule, EnergyTranslateModule} from 'energy-frame-lib';


import {ReactiveFormsModule} from '@angular/forms';
import {TenantConfigService} from '@rsp/shared/services/tenant-config.service';
import {UserService} from '@rsp/shared/services/user.service';
import {SharedModule} from '@rsp/shared/shared.module';
import {AppRouterModule} from '@rsp/app.routes';
import {AppComponent} from '@rsp/app.component';
import {HeaderComponent} from '@rsp/shared/layout/header/header.component';
import {LandingComponent} from '@rsp/landing/landing.component';
import {ImpressumComponent} from '@rsp/impressum/impressum.component';
import {CommunityComponent} from '@rsp/community/community.component';
import {StrombilanzComponent} from '@rsp/strombilanz/strombilanz.component';
import {AuthGuard} from '@rsp/shared/guards/auth.guard';
import {RoleGuard} from '@rsp/shared/guards/role.guard';
import {environment} from '@env/environment';
import {ImageUrlBuilderService} from '@rsp/shared/services/image-url-builder.service';
import {RegionalAuthService} from '@rsp/shared/services/regional-auth.service';
import {ImageUrlBuilderMockService} from '@mock/image-url-builder.mock.service';
import {RspHttpInterceptor} from '@mock/rsp-http.interceptor';
import {NoopHttpInterceptor} from '@mock/noop-http.interceptor';
import moment from 'moment';
import {MatomoModule} from 'ngx-matomo';


registerLocaleData(localeDe, 'de');

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function setTenantInfosFactory(provider: TenantConfigService, userServiceProvider: UserService) {
  return () => Promise.all([provider.init(), userServiceProvider.init()]);
}

moment.locale('de');

Highcharts.setOptions({
  lang: {
    numericSymbols: [' Tsd.', ' Mil.'],
    months: [
      'Januar', 'Februar', 'März', 'April',
      'Mai', 'Juni', 'Juli', 'August',
      'September', 'Oktober', 'November', 'Dezember'
    ],
    weekdays: [
      'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag',
      'Freitag', 'Samstag', 'Sonntag'
    ],
    shortMonths: [
      'Jan', 'Feb', 'Mrz', 'Apr',
      'Mai', 'Jun', 'Jul', 'Aug',
      'Sep', 'Okt', 'Nov', 'Dez'
    ],
    printChart: 'Diagramm drucken',
    downloadPNG: 'PNG Bild herunterladen',
    downloadJPEG: 'JPEG Bild herunterladen',
    downloadPDF: 'PDF Dokument herunterladen',
    downloadSVG: 'SVG Vector Bild herunterladen',
    resetZoom: 'Zoom zurücksetzen',
    thousandsSep: '.'
  }
});

const EXPANSION_PANEL_ANIMATION_TIMING = '10000ms cubic-bezier(0.4,0.0,0.2,1)';


@NgModule({
  imports: [
    EnergyFrameModule,
    EnergyTranslateModule.forRoot([]),
    ChartModule,
    ...MATERIAL,
    FlexLayoutModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CommonModule,
    // MomentModule,
    SharedModule.forRoot(),
    AppRouterModule,
    ReactiveFormsModule,
    MatomoModule,

  ],
  declarations: [
    AppComponent,
    HeaderComponent,
    LandingComponent,
    ImpressumComponent,
    CommunityComponent,
    StrombilanzComponent,
  ],

  providers: [
    // {provide: AuthConfig, useValue: authConfig},
    AuthGuard,
    RoleGuard,
    UserService,
    {provide: BASE_URL, useValue: environment.baseUrl},
    Title,
    {provide: HIGHCHARTS_MODULES, useFactory: () => [more, exporting]},
    {provide: LOCALE_ID, useValue: 'de'},
    {provide: ImageUrlBuilderService, useClass: environment.mock ? ImageUrlBuilderMockService : ImageUrlBuilderService},
    TenantConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: setTenantInfosFactory,
      deps: [TenantConfigService, UserService],
      multi: true
    },
    RegionalAuthService,
    {provide: HTTP_INTERCEPTORS, useClass: environment.mock ? RspHttpInterceptor : NoopHttpInterceptor, multi: true},
    {provide: EXPANSION_PANEL_ANIMATION_TIMING, useValue: '5000ms cubic-bezier(0.4,0.0,0.2,1)'}  // does not work
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
}
